import { useLocation } from "react-router-dom";

/**
 * Botón flotante de WhatsApp — usa wa.me directo (no requiere Meta API).
 * Se oculta en rutas privadas (admin, cliente logueado, socios internas).
 * El número se lee de REACT_APP_WHATSAPP_NUMBER (E.164 sin '+').
 * Ej: REACT_APP_WHATSAPP_NUMBER=525512345678
 */
const HIDDEN_PREFIXES = ["/admin", "/proveedor", "/socios/portal", "/socios/pagos"];

const MESSAGE_BY_ROUTE = [
  { match: (p) => p.startsWith("/cuenta"), msg: "Hola, soy socio y necesito ayuda con mi cuenta de Mi Ángel Asís." },
  { match: (p) => p === "/completo" || p.startsWith("/planes"), msg: "Hola, me interesa una membresía familiar de Mi Ángel Asís." },
  { match: (p) => p.startsWith("/campana") || p.startsWith("/socios"), msg: "Hola, me interesa el programa de Embajadores de Mi Ángel Asís." },
];
const DEFAULT_MSG = "Hola, quiero información sobre Mi Ángel Asís.";

export default function WhatsAppFloat() {
  const { pathname } = useLocation();
  const number = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/[^0-9]/g, "");
  if (!number) return null;
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  const match = MESSAGE_BY_ROUTE.find((r) => r.match(pathname));
  const text = encodeURIComponent(match?.msg || DEFAULT_MSG);
  const href = `https://wa.me/${number}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Contactar por WhatsApp"
      onClick={() => {
        try {
          window.gtag?.("event", "whatsapp_click", { route: pathname });
          window.ttq?.track("ClickButton", { button_name: "whatsapp_float", route: pathname });
        } catch { /* best-effort tracking */ }
      }}
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        width: 60,
        height: 60,
        background: "#25D366",
        color: "white",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 24px rgba(37, 211, 102, 0.45), 0 2px 8px rgba(0,0,0,0.15)",
        zIndex: 9999,
        fontSize: 28,
        textDecoration: "none",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        animation: "wa-float-pulse 2.4s ease-in-out infinite",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.08)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      <i className="fab fa-whatsapp" />
      <style>{`
        @keyframes wa-float-pulse {
          0%, 100% { box-shadow: 0 6px 24px rgba(37, 211, 102, 0.45), 0 2px 8px rgba(0,0,0,0.15); }
          50% { box-shadow: 0 6px 24px rgba(37, 211, 102, 0.75), 0 0 0 10px rgba(37, 211, 102, 0.12); }
        }
      `}</style>
    </a>
  );
}
